import { WidgetRegistry } from "@emkit/builder-core";
import { accordionWidget } from "./accordion.js";
import { alertWidget } from "./alert.js";
import { audioWidget } from "./audio.js";
import { badgeWidget } from "./badge.js";
import { breadcrumbsWidget } from "./breadcrumbs.js";
import { buttonWidget } from "./button.js";
import { carouselWidget } from "./carousel.js";
import { chartWidget } from "./chart.js";
import { codeWidget } from "./code.js";
import { countdownWidget } from "./countdown.js";
import { ctaBannerWidget } from "./cta-banner.js";
import { dividerWidget } from "./divider.js";
import { faqWidget } from "./faq.js";
import { featuresWidget } from "./features.js";
import { formWidget } from "./form.js";
import { galleryWidget } from "./gallery.js";
import { headingWidget } from "./heading.js";
import { heroWidget } from "./hero.js";
import { htmlWidget } from "./html.js";
import { iconListWidget } from "./icon-list.js";
import { imageWidget } from "./image.js";
import { logoBarWidget } from "./logo-bar.js";
import { mapWidget } from "./map.js";
import { navMenuWidget } from "./nav-menu.js";
import { newsletterWidget } from "./newsletter.js";
import { pricingWidget } from "./pricing.js";
import { productCardWidget } from "./product-card.js";
import { progressWidget } from "./progress.js";
import { quoteWidget } from "./quote.js";
import { shareWidget } from "./share.js";
import { socialLinksWidget } from "./social-links.js";
import { spacerWidget } from "./spacer.js";
import { statsWidget } from "./stats.js";
import { stepsWidget } from "./steps.js";
import { tabsWidget } from "./tabs.js";
import { teamWidget } from "./team.js";
import { testimonialsWidget } from "./testimonials.js";
import { textWidget } from "./text.js";
import { timelineWidget } from "./timeline.js";
import { videoWidget } from "./video.js";
export * from "./heading.js";
export * from "./text.js";
export * from "./image.js";
export * from "./button.js";
export * from "./spacer.js";
export * from "./divider.js";
export * from "./video.js";
export * from "./html.js";
export * from "./form.js";
export * from "./accordion.js";
export * from "./tabs.js";
export * from "./gallery.js";
export * from "./icon-list.js";
export * from "./hero.js";
export * from "./pricing.js";
export * from "./testimonials.js";
export * from "./stats.js";
export * from "./features.js";
export * from "./logo-bar.js";
export * from "./cta-banner.js";
export * from "./faq.js";
export * from "./alert.js";
export * from "./quote.js";
export * from "./social-links.js";
export * from "./progress.js";
export * from "./badge.js";
export * from "./code.js";
export * from "./map.js";
export * from "./countdown.js";
export * from "./breadcrumbs.js";
export * from "./nav-menu.js";
export * from "./share.js";
export * from "./audio.js";
export * from "./chart.js";
export * from "./team.js";
export * from "./steps.js";
export * from "./timeline.js";
export * from "./newsletter.js";
export * from "./carousel.js";
export * from "./product-card.js";
export * from "./sanitize.js";
/**
 * Register all built-in widgets on a given registry.
 * Call this at app bootstrap unless you're building a custom allowlist.
 */
export function registerBuiltins(registry) {
    registry
        .register(headingWidget)
        .register(textWidget)
        .register(imageWidget)
        .register(buttonWidget)
        .register(spacerWidget)
        .register(dividerWidget)
        .register(videoWidget)
        .register(htmlWidget)
        .register(formWidget)
        .register(accordionWidget)
        .register(tabsWidget)
        .register(galleryWidget)
        .register(iconListWidget)
        .register(heroWidget)
        .register(pricingWidget)
        .register(testimonialsWidget)
        .register(statsWidget)
        .register(featuresWidget)
        .register(logoBarWidget)
        .register(ctaBannerWidget)
        .register(faqWidget)
        .register(alertWidget)
        .register(quoteWidget)
        .register(socialLinksWidget)
        .register(progressWidget)
        .register(badgeWidget)
        .register(codeWidget)
        .register(mapWidget)
        .register(countdownWidget)
        .register(breadcrumbsWidget)
        .register(navMenuWidget)
        .register(shareWidget)
        .register(audioWidget)
        .register(chartWidget)
        .register(teamWidget)
        .register(stepsWidget)
        .register(timelineWidget)
        .register(newsletterWidget)
        .register(carouselWidget)
        .register(productCardWidget);
    return registry;
}
/**
 * Convenience: create a fresh registry already loaded with the builtins.
 */
export function createBuiltinRegistry() {
    return registerBuiltins(new WidgetRegistry());
}
//# sourceMappingURL=index.js.map